<!-- Доменная кнопка ПЛАНа/ФАКТа: хранит локальные цвета и плотность действий. -->
<template>
  <BaseButton
    class="plan-action-button"
    :class="[
      `plan-action-button--${tone}`,
      `plan-action-button--${appearance}`,
      { 'plan-action-button--regular': size === 'regular' },
      { 'plan-action-button--dense': size === 'dense' },
    ]"
    :variant="appearance === 'solid' ? 'primary' : 'secondary'"
    v-bind="$attrs"
    @click="$emit('click', $event)"
  >
    <slot />
  </BaseButton>
</template>

<script>
export default {
  name: "OrderPlanCalculationActionButton",

  inheritAttrs: false,

  props: {
    tone: {
      type: String,
      default: "plan",
      validator: (value) => ["plan", "fact"].includes(value),
    },
    appearance: {
      type: String,
      default: "solid",
      validator: (value) => ["solid", "soft"].includes(value),
    },
    size: {
      type: String,
      default: "compact",
      validator: (value) => ["dense", "compact", "regular"].includes(value),
    },
  },

  emits: ["click"],
};
</script>

<style scoped>
.plan-action-button {
  height: 32px;
  min-height: 32px;
  padding: 0 12px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
}

.plan-action-button--regular {
  height: 34px;
  min-height: 34px;
  padding: 0 14px;
}

.plan-action-button--dense {
  height: 28px;
  min-height: 28px;
  padding: 0 10px;
  font-size: 12px;
}

.plan-action-button--plan.plan-action-button--solid {
  border-color: #3b5bdb;
  background: #3b5bdb;
  color: #fff;
}

.plan-action-button--fact.plan-action-button--solid {
  border-color: #c2410c;
  background: #c2410c;
  color: #fff;
}

.plan-action-button--fact.plan-action-button--soft {
  border-color: #fdba74;
  background: #fff7ed;
  color: #9a3412;
}
</style>
